/**
 * Auth contract. Better Auth mounts its own routes under /api/auth/*.
 * These types describe the session shape the SPA and API guards rely on.
 */
/** Base path Better Auth handler is mounted at on the API. */
export const AUTH_BASE_PATH = '/api/auth';
//# sourceMappingURL=auth.contract.js.map